export default "__VITE_ASSET__BVpFVuIc__"